import React, { useState, useRef, useEffect } from 'react';
import { FaRobot, FaTimes, FaPaperPlane, FaTrash } from 'react-icons/fa';
import api from '../../services/api';

const SALUDO = { rol: 'asistente', texto: 'Hola, soy tu asistente financiero. ¿En qué puedo ayudarte?' };

export default function AsistenteFlotante() {
  const [abierto,   setAbierto]   = useState(false);
  const [mensajes,  setMensajes]  = useState(() => {
    try {
      const guardado = localStorage.getItem('chat_asistente');
      return guardado ? JSON.parse(guardado) : [SALUDO];
    } catch { return [SALUDO]; }
  });
  const [input,     setInput]     = useState('');
  const [cargando,  setCargando]  = useState(false);
  const finRef = useRef(null);

  useEffect(() => { finRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [mensajes]);

  useEffect(() => {
    try { localStorage.setItem('chat_asistente', JSON.stringify(mensajes)); } catch {}
  }, [mensajes]);



  const enviar = async () => {
    if (!input.trim() || cargando) return;
    const pregunta = input.trim();
    setMensajes(prev => [...prev, { rol: 'usuario', texto: pregunta }]);
    setInput('');
    setCargando(true);
    try {
      const { data } = await api.post('/asistente/chat', { mensaje: pregunta });
      const respuesta = data.data?.respuesta || data.respuesta || 'No pude procesar tu consulta.';
      setMensajes(prev => [...prev, { rol: 'asistente', texto: respuesta }]);
    } catch {
      setMensajes(prev => [...prev, { rol: 'asistente', texto: 'Ocurrió un error. Intenta de nuevo.' }]);
    } finally {
      setCargando(false);
    }
  };

  const borrarHistorial = async () => {
    if (!window.confirm('¿Borrar todo el historial de conversación?')) return;
    try {
      await api.delete('/asistente/historial');
      setMensajes([SALUDO]);
      localStorage.removeItem('chat_asistente');
    } catch {}
  };

  return (
    <>
      {!abierto && (
        <button onClick={() => setAbierto(true)} style={{
          position: 'fixed', bottom: 24, right: 24, width: 58, height: 58, borderRadius: '50%',
          background: 'linear-gradient(135deg, #FF7A00, #FF9A3C)', border: 'none', cursor: 'pointer', zIndex: 999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 24px rgba(255,122,0,0.4)', transition: 'transform .2s',
        }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        >
          <FaRobot size={24} color="#fff" />
        </button>
      )}
      {abierto && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24, width: 360, height: 500, background: '#fff',
          borderRadius: 16, zIndex: 999, boxShadow: '0 16px 48px rgba(0,27,92,0.25)',
          display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid #E2E8F0',
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #001B5C, #0A2A6E)', padding: '16px 18px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 34, height: 34, borderRadius: '50%',
                background: 'linear-gradient(135deg, #FF7A00, #FF9A3C)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <FaRobot size={16} color="#fff" />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>Asistente IA</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)' }}>En línea</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={borrarHistorial} title="Borrar historial" style={{
                background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff',
                width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <FaTrash size={11} />
              </button>
              <button onClick={() => setAbierto(false)} style={{
                background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff',
                width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <FaTimes size={13} />
              </button>
            </div>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: 16, background: '#F8FAFC' }}>
            {mensajes.map((m, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: m.rol === 'usuario' ? 'flex-end' : 'flex-start', marginBottom: 10 }}>
                <div style={{
                  maxWidth: '80%', padding: '10px 14px', borderRadius: 12, fontSize: 13, lineHeight: 1.5,
                  background: m.rol === 'usuario' ? 'linear-gradient(135deg, #FF7A00, #E55A00)' : '#fff',
                  color: m.rol === 'usuario' ? '#fff' : '#1E293B',
                  border: m.rol === 'usuario' ? 'none' : '1px solid #E2E8F0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                }}>
                  {m.texto}
                </div>
              </div>
            ))}
            {cargando && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 10 }}>
                <div style={{ padding: '10px 14px', borderRadius: 12, background: '#fff', border: '1px solid #E2E8F0', fontSize: 13, color: '#94A3B8' }}>
                  Escribiendo...
                </div>
              </div>
            )}
            <div ref={finRef} />
          </div>
          <div style={{ padding: 12, borderTop: '1px solid #E2E8F0', display: 'flex', gap: 8 }}>
            <input value={input} onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && enviar()} placeholder="Escribe tu consulta..."
              style={{ flex: 1, padding: '10px 14px', borderRadius: 10, border: '1.5px solid #E2E8F0', outline: 'none', fontSize: 13, fontFamily: 'Inter, sans-serif' }}
              onFocus={e => e.target.style.borderColor = '#FF7A00'} onBlur={e => e.target.style.borderColor = '#E2E8F0'} />
            <button onClick={enviar} disabled={cargando} style={{
              width: 42, height: 42, borderRadius: 10, background: 'linear-gradient(135deg, #FF7A00, #E55A00)',
              border: 'none', cursor: cargando ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <FaPaperPlane size={14} color="#fff" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
